export default __webpack_public_path__ + "static/media/money1.ec50af15.jpg";